import {
  EDealType,
  EOfferTypes,
} from '../../repositories/billing-service-packages-balancer/entities/Purchase/BuyCustomPackageRequestV5';
import { IBuyCustomPackageRequest } from '../../repositories/billing-service-packages-balancer/v5/buy-custom-package';
import { TAppState } from '../../types';
import { selectBuyPackageModalData } from '../buyPackageModal';
import { mapService } from './utils';

/**
 * Конвертирует дату из формата DD.MM.YYYY в YYYY-MM-DD.
 * Решил сделать без применения библиотеки, так как операция примитивная.
 * Если изменится формат, применение библиотеки не отменит необходимости править код.
 */
const formatDate = (date: string): string => {
  return date.split('.').reverse().join('-');
};

export const selectBuyCustomPackageParams = (state: TAppState): IBuyCustomPackageRequest => {
  const { activationDate, durationInDays, polygonIds, services, autoProlong, dealType, offerTypes } =
    selectBuyPackageModalData(state);

  return {
    items: services.map(mapService),
    dealType: dealType as string as EDealType,
    offerTypes: offerTypes as string[] as EOfferTypes[],
    polygonIds: polygonIds!,
    activationDate: formatDate(activationDate),
    durationInDays,
    autoProlong,
  };
};
